import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import { addQueryArgs } from '@wordpress/url';
import apiFetch from '@wordpress/api-fetch';
import { Fragment } from '@wordpress/element';
/**
 * WooCommerce dependencies
 */

import { getQuery } from '@woocommerce/navigation';
/**
 * Internal dependencies
 */

import { computeSuggestionMatch } from './utils';
import ProductImage from '../../product-image';
/**
 * Create a variation name by concatenating each of the variation's
 * attribute option strings.
 *
 * @param {object} variation - variation returned by the api
 * @returns {string} - variation name
 */

function getVariationName(variation) {
  return variation.attributes.reduce(function (desc, attribute, index, arr) {
    return desc + "".concat(attribute.option).concat(arr.length === index + 1 ? '' : ', ');
  }, '');
}
/**
 * A products completer.
 * See https://github.com/WordPress/gutenberg/tree/master/packages/components/src/autocomplete#the-completer-interface
 *
 * @type {Completer}
 */


export default {
  name: 'products',
  className: 'woocommerce-search__product-result',
  options: function options(search) {
    var query = search ? {
      search: search,
      per_page: 10
    } : {};
    var product = getQuery().products;

    if (!product || product.includes(',')) {
      console.warn('Invalid product id supplied to Variations autocompleter');
    }

    return apiFetch({
      path: addQueryArgs("/wc-analytics/products/".concat(product, "/variations"), query)
    });
  },
  isDebounced: true,
  getOptionIdentifier: function getOptionIdentifier(variation) {
    return variation.id;
  },
  getOptionKeywords: function getOptionKeywords(variation) {
    return [getVariationName(variation), variation.sku];
  },
  getOptionLabel: function getOptionLabel(variation, query) {
    var match = computeSuggestionMatch(getVariationName(variation), query) || {};
    return createElement(Fragment, null, createElement(ProductImage, {
      key: "thumbnail",
      className: "woocommerce-search__result-thumbnail",
      product: variation,
      width: 18,
      height: 18,
      alt: ""
    }), ",", createElement("span", {
      key: "name",
      className: "woocommerce-search__result-name",
      "aria-label": variation.description
    }, match.suggestionBeforeMatch, createElement("strong", {
      className: "components-form-token-field__suggestion-match"
    }, match.suggestionMatch), match.suggestionAfterMatch), ",");
  },
  // This is slightly different than gutenberg/Autocomplete, we don't support different methods
  // of replace/insertion, so we can just return the value.
  getOptionCompletion: function getOptionCompletion(variation) {
    return {
      key: variation.id,
      label: getVariationName(variation)
    };
  }
};
//# sourceMappingURL=variations.js.map